import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, AfterViewChecked } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/AppConsts';
import {
    ProfileServiceProxy,
    CurrentUserProfileEditDto,
    UpdateGoogleAuthenticatorKeyOutput
} from '@shared/service-proxies/service-proxies';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { SmsVerificationModalComponent } from './sms-verification-modal.component';

@Component({
    selector: 'mySettingsModal',
    templateUrl: './my-settings-modal.component.html'
})
export class MySettingsModalComponent extends AppComponentBase implements AfterViewChecked {
    @ViewChild('nameInput')
    nameInput: ElementRef;
    @ViewChild('mySettingsModal')
    modal: ModalDirective;
    @ViewChild('smsVerificationModal')
    smsVerificationModal: SmsVerificationModalComponent;
    @Output()
    modalSave: EventEmitter<any> = new EventEmitter<any>();

    public active: boolean = false;
    public saving: boolean = false;
    public isPhoneNumberConfirmed: boolean;
    public isPhoneNumberEmpty: boolean = false;
    public smsEnabled: boolean;
    public user: CurrentUserProfileEditDto;
    public titles: string[] = ['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Prof.'];
    public showTimezoneSelection: boolean = abp.clock.provider.supportsMultipleTimezone;
    public canChangeUserName: boolean;
    public defaultTimezoneScope: any = 0;
    private _initialTimezone: string = undefined;
    public isGoogleAuthenticatorEnabled: boolean = false;
    public isTwoFactorHostEnabled: boolean = false;
    public isTwoFactorSmsProviderEnabled: boolean = false;
    public isTwoFactorGoogleAuthProviderEnabled: boolean = false;
    public isTwoFactorEnabled: boolean = false;

    constructor(injector: Injector, private _profileService: ProfileServiceProxy, private _appSessionService: AppSessionService) {
        super(injector);
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }

    show(): void {
        this.active = true;
        this._profileService.getCurrentUserProfileForEdit().subscribe((result) => {
            this.smsEnabled = this.setting.getBoolean('App.UserManagement.SmsVerificationEnabled');
            this.user = result;
            this._initialTimezone = result.timezone;
            this.canChangeUserName = this.user.userName !== AppConsts.userManagement.defaultAdminUserName;
            this.modal.show();
            this.isPhoneNumberConfirmed = result.isPhoneNumberConfirmed;
            this.isPhoneNumberEmpty = result.phoneNumber === '';
            this.isGoogleAuthenticatorEnabled = result.isGoogleAuthenticatorEnabled;
            this.isTwoFactorHostEnabled = this.setting.getBoolean('Abp.Zero.UserManagement.TwoFactorLogin.IsEnabled');
            this.isTwoFactorSmsProviderEnabled = this.setting.getBoolean('Abp.Zero.UserManagement.TwoFactorLogin.IsSmsProviderEnabled');
            this.isTwoFactorGoogleAuthProviderEnabled = this.setting.getBoolean(
                'App.UserManagement.TwoFactorLogin.IsGoogleAuthenticatorEnabled'
            );
            this.isTwoFactorEnabled = result.isTwoFactorEnabled;
        });
    }

    smsVerify(): void {
        this._profileService.sendVerificationSms().subscribe(() => {
            this.smsVerificationModal.show();
        });
    }

    updateQrCodeSetupImageUrl(enabled: boolean): void {
        if (enabled) {
            this._profileService.updateGoogleAuthenticatorKey().subscribe((result: UpdateGoogleAuthenticatorKeyOutput) => {
                this.user.qrCodeSetupImageUrl = result.qrCodeSetupImageUrl;
                this.isGoogleAuthenticatorEnabled = true;
                this.user.isGoogleAuthenticatorEnabled = true;
            });
        } else {
            this.user.isGoogleAuthenticatorEnabled = false;
            this.isGoogleAuthenticatorEnabled = false;
        }
    }

    toggleSmsAuthentication(enabled: boolean): void {
        this.user.isSmsAuthenticationEnabled = enabled;
    }

    changePhoneNumberToVerified(): void {
        this.isPhoneNumberConfirmed = true;
    }

    onShown(): void {
        $(this.nameInput.nativeElement).focus();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    save(): void {
        this.saving = true;
        this._profileService
            .updateCurrentUserProfile(this.user)
            .finally(() => {
                this.saving = false;
            })
            .subscribe(() => {
                this._appSessionService.user.name = this.user.name;
                this._appSessionService.user.surname = this.user.surname;
                this._appSessionService.user.userName = this.user.userName;
                this._appSessionService.user.emailAddress = this.user.emailAddress;

                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);

                if (abp.clock.provider.supportsMultipleTimezone && this._initialTimezone !== this.user.timezone) {
                    this.message.info(this.l('TimeZoneSettingChangedRefreshPageNotification')).done(() => {
                        window.location.reload();
                    });
                }
            });
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/layout/profile/my-settings-modal.component.ts